import { is_device } from './DeviceID';
import type { DeviceID } from './DeviceID';

export interface DeviceAction {
	name: string;
	value: string | number | Record<string, any>;
	type?: string;
	index?: number;
	addOnInd?: number;
	slot?: string; // For diffuser actions (left/right)
}

export interface DelayActionUI {
	units: 'm' | 's' | 'min' | 'sec';
	value: number | string | undefined;
}
export interface DelayArmActionUI {
	units: 'min' | 'sec';
	value: number;
}

export interface TimerUI extends DelayActionUI {}

export interface DeviceActionUI {
	device: DeviceID;
	actions: DeviceAction[];
	delay: DelayActionUI | undefined;
	timer: TimerUI | undefined;
}

export function is_device_action_ui(obj: any): obj is DeviceActionUI {
	return typeof obj === 'object' && typeof obj.actions !== 'undefined' && is_device(obj.device);
}
